import { authSession } from './runtime'
import { parseSession } from './auth-api'
import { isUuid } from './http'
export const paymentReturn = { orderId: null, error: null }
export async function restorePaymentReturn() {
  const hash = window.location.hash
  const query = new URLSearchParams(hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : '')
  const id = query.get('paymentReturn')
  paymentReturn.error = query.get('paymentError')
  if (!id || !isUuid(id)) return
  paymentReturn.orderId = id
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), 15000)
  try {
    const response = await fetch('/api/payments/wechat/return', {
      method: 'POST', credentials: 'same-origin', redirect: 'error', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ orderId: id }), signal: controller.signal,
    })
    if (!response.ok) throw new Error('PAYMENT_RETURN_EXPIRED')
    const returned = await response.json()
    if (returned.orderId !== id) throw new Error('PAYMENT_RETURN_EXPIRED')
    authSession.applyPaymentReturn(parseSession(returned.session))
    paymentReturn.error = returned.error
  } catch (error) {
    paymentReturn.error = ['PAYMENT_RETURN_ACCOUNT_MISMATCH', 'PAYMENT_AUTH_EXPIRED'].includes(error.code) ? error.code : 'PAYMENT_RETURN_EXPIRED'
    if (error.code === 'PAYMENT_RETURN_ACCOUNT_MISMATCH' || error.code === 'PAYMENT_AUTH_EXPIRED') paymentReturn.orderId = null
  } finally { clearTimeout(timer) }
}
